import React from "react";
import ErrorRenderer from "./ErrorRenderer";
import { ErrorModel } from "../../models/ErrorModel";

interface Props {
    errors: ErrorModel[];
}

interface State {}

export class ErrorLog extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
    }

    render() {
        return (
            <div className="errors-log">
                <ul className="errors">
                    {this.props.errors.map((e: ErrorModel, i: number) => (
                        <li key={i}>
                            <ErrorRenderer error={e.error} />
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}
